export const KNIT_BEANIE_STYLE = ".pplr-choose-style .pplr-drop-item._pplr_knit_beanies";
export const STYLE_ITEMS = ".pplr-choose-style .pplr-drop-item";
export const SIZE_SPANS = ".pplr-choose-size span.pplr-drop-item";
